import axios from 'axios'
import _ from 'lodash';
import { loadProfile } from './avatar'
import { displayNotificationMessage } from './index'
import { toDateString, getDaysSinceWeighIn } from '../views/dashboard/util'
import config from '../config'
const API_ROOT = config.API_ROOT

export function getCheckIns(user_id) {
  return (dispatch) => {
    dispatch({ type: 'FETCH_CHECKINS' })
    return new Promise((resolve, reject) => {
      // Load all Check Ins for now
      axios.get(`${API_ROOT}/check-ins/${user_id}/300/0`, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }}).then((res) => {
        if(res.data.check_ins)
          dispatch({ type: 'FETCH_CHECKINS_FULFILLED', payload: res.data });
        resolve(res)
      }).catch((err) => {
        dispatch({ type: 'FETCH_CHECKINS_REJECTED', payload: { response: err.response.data }})
        reject(err)
      })
    })
  }
}

export function editWeighIn(request) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios.put(API_ROOT + '/weighins/', request,  { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }}).then((res) => {
        if(res.data.coaching)
          dispatch(displayNotificationMessage(res.data.coaching))
        dispatch({ type: 'EDIT_WEIGH_IN_FULFILLED', payload: res.data });
        dispatch(loadProfile(request.user_id));
        resolve(res)
      }).catch((err) => {
        dispatch({ type: 'EDIT_WEIGH_IN_REJECTED', payload: { response: err.response.data }})
        reject(err)
      })
    })
  }
}

export function keepTargets(user_id, report_date) {
  const request = {
    action: 'Edit',
    edits: {
      keep: 1,
      report_date: report_date
    },
    user_id: user_id
  }
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios.put(API_ROOT + '/weighins/', request,  { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }}).then((res) => {
        dispatch({ type: 'KEEP_TARGETS_FULFILLED', payload: res.data });
        dispatch(loadProfile(request.user_id));
        resolve(res)
      }).catch((err) => {
        dispatch({ type: 'KEEP_TARGETS_REJECTED', payload: { response: err.response.data }})
        reject(err)
      })
    })
  }
}

export function keepTargetsWithReason(user_id, report_date, reason_code, reason_text, skipCarryOverReason) {
  const request = {
    action: 'Edit',
    edits: {
      keep: 1,
      reason_code: reason_code,
      reason_text: reason_text,
      report_date: report_date
    },
    user_id: user_id
  }
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios.put(API_ROOT + '/weighins/', request,  { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }}).then((res) => {
        if(skipCarryOverReason) {
          axios.put(API_ROOT + '/auxiliary/' + user_id, { skip_carry_over_reason: 1 }, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }}).then((res) => {
            dispatch({ type: 'KEEP_TARGETS_WITH_REASON_FULFILLED', payload: res.data })
            dispatch(loadProfile(request.user_id))
            resolve(res)
          }).catch((err) => reject(err));
        } else {
          dispatch({ type: 'KEEP_TARGETS_WITH_REASON_FULFILLED', payload: res.data });
          dispatch(loadProfile(request.user_id));
          resolve(res)
        }
      }).catch((err) => {
        dispatch({ type: 'KEEP_TARGETS_WITH_REASON_REJECTED', payload: { response: err.response.data }})
        reject(err)
      })
    })
  }
}

export function editCheckWeighIn(request) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios.put(API_ROOT + '/weighins/', request,  { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }}).then((res) => {
        dispatch(loadProfile(request.user_id));
        resolve(res)
      }).catch((err) => { reject(err) })
    })
  }
}

export function editAddWeighIn(request) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios.put(API_ROOT + '/weighins/', request,  { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }}).then((res) => {
        if(getDaysSinceWeighIn(request.edits.report_date) < 5) // Compliant was forced on user, coaching message won't make sense
          dispatch({ type: 'EDITADD_WEIGH_IN_FULFILLED_NO_COACH', payload: res.data })
        else
          dispatch({ type: 'EDITADD_WEIGH_IN_FULFILLED', payload: res.data });
        dispatch(loadProfile(request.user_id));
        resolve(res)
      }).catch((err) => { reject(err) })
    })
  }
}

export function insertWeighIn(id, weight, bf, compliant, near_period, menstrual_within_5, menstrual_retaining, skipNearPeriod, goal_change_requested, activity_level_change_requested, mods, estimated_weight, measurements) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      const req = {
        user_id: id,
        weight: weight,
        estimated_weight: estimated_weight,
        body_fat: bf,
        compliant: compliant,
        near_period: near_period,
        menstrual_within_5: menstrual_within_5,
        menstrual_retaining: menstrual_retaining,
        goal_change_requested: goal_change_requested,
        activity_level_change_requested: activity_level_change_requested,
        local_today: toDateString(new Date()),
        measurements: measurements ?? {},
      }

      if(skipNearPeriod)
        req['skip_near_period'] = skipNearPeriod

      axios.post(API_ROOT + '/weighins/', req, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
        .then((res) => {
          if(_.size(mods) > 0) {
            mods['local_today'] = toDateString(new Date());
            axios.put(API_ROOT + '/users/' + id, mods, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }})
            .then((res) => {
              setTimeout(() => dispatch({ type: 'WEIGH_IN_AND_MODIFY_USER_FULFILLED', payload: res.data }), 2000);
              setTimeout(() => dispatch(loadProfile(id)), 2000);
              resolve(res)
            }).catch((err) => reject(err));
          } else {
            setTimeout(() => dispatch({ type: 'WEIGH_IN_FULFILLED', payload: Object.assign({}, res.data, { report_date: req.local_today }) }), 2000);
            setTimeout(() => dispatch(loadProfile(id)), 2000);
            resolve(res);
          }
        }).catch((err) => {
          dispatch({ type: 'WEIGH_IN_REJECTED',
          payload: {
              message: 'Unable to submit check-in. Please try again'
          }
        })
        reject(err);
      })
    });
  }
}

// Add new function for reset macros weigh-in to not clutter insertWeighin function.
export function insertResetWeighin(id, weight, bf, near_period, menstrual_within_5, menstrual_retaining, estimated_weight, deleteHistory) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      const todaysDate = toDateString(new Date())
      const req = {
        user_id: id,
        weight: weight,
        body_fat: bf,
        compliant: 1,
        near_period: near_period,
        menstrual_within_5: menstrual_within_5,
        menstrual_retaining: menstrual_retaining,
        estimated_weight: estimated_weight,
        local_today: todaysDate
      }
      axios.post(API_ROOT + '/weighins/', req, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') } }).then((res) => {
        return axios.put(API_ROOT + '/users/' + id, {
          starting_point: todaysDate,
          maintenance_calories: 0,
          delete_history: deleteHistory,
          local_today: todaysDate
        }, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') } })
      }).then((res) => {
        setTimeout(() => dispatch({ type: 'ADD_RESET_WEIGHIN_FULFILLED', payload: res.data }), 2000);
        setTimeout(() => dispatch(loadProfile(id)), 2000);
        resolve(res)
      }).catch((err) => {
        dispatch({
          type: 'WEIGH_IN_REJECTED',
          payload: {
            message: 'Unable to submit check-in. Please try again'
          }
        })
        reject(err);
      })
    })
  }
}

export function resumeWeighIn(id, weight, bf, near_period, menstrual_within_5, menstrual_retaining, skipNearPeriod, estimatedWeight) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      const req = {
        weight: weight,
        body_fat: bf,
        near_period: near_period,
        menstrual_within_5: menstrual_within_5,
        menstrual_retaining: menstrual_retaining,
        local_today: toDateString(new Date()),
        estimated_weight: estimatedWeight,
      }

      if(skipNearPeriod)
        req['skip_near_period'] = skipNearPeriod

      if(estimatedWeight)
        req['estimated_weight'] = estimatedWeight

      axios.post(API_ROOT + '/resume/' + id, req, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }}).then(
        res => {
          setTimeout(() => dispatch({ type: 'RESUME_FULFILLED', payload: res.data }), 2000);
          setTimeout(() => dispatch(loadProfile(id)), 2000);
        },
        err => dispatch({ type: 'RESUME_REJECTED', payload: {
            message: 'Unable to submit check-in. Please try again'
          }
        })
      )
    })
  }
}
